<template lang="pug">
.ServiceParams
  .ServiceParams-spinner
    fade-loader.Spinner(
      :loading='isLoading',
      color='#27bd8a',
      height='8px',
      width='3px',
      radius='10px'
    )

  .ServiceParams-label(v-if='!isLoading') Процесс
  .ServiceParams-title(v-if='!isLoading') {{ selectedService.name }}
  .ServiceParams-fields(v-if='!isLoading')
    div(v-for='field in formFields')
      .ServiceField(v-if='field.isVisible')
        .ServiceField-label(v-if='field.type !== "bool" && field.type !== "checkbox"') {{ field.label }}
        template(v-if='field.type === "list"')
          .ListItem(v-for='(listItem, listItemIndex) in field.value')
            .ListItem-period {{ periodsDates[listItemIndex].name }}
            .ListItem-field
              input.TextInput.TextInput--block(
                type='number',
                :class='{ "TextInput--error": field.errors && field.errors.length > 0 }',
                v-model='field.value[listItemIndex]'
              )
        switcher(
          v-if='field.type === "bool" || field.type === "checkbox"',
          v-model='field.value',
          @toggle='updateLinkedFields()'
        ) {{ field.label }}
        period-interval(
          v-if='field.type === "period"',
          :hasError='field.errors && field.errors.length > 0',
          :initialSelection='field.value',
          @select='updatePeriod(field, $event)'
        )
        input.TextInput.TextInput--block(
          type='text',
          v-if='field.type === "str"',
          :class='{ "TextInput--error": field.errors && field.errors.length > 0 }',
          v-model='field.value'
        )
        .FileInput.FileInput--block(
          v-if='fileTypes.indexOf(field.type) > -1',
          @dragover='dragoverprevent',
          @drop.prevent='addFile($event, field)'
        )
          label(v-if='!field.url')
            span(v-if='selectedService.id === "workspace"') {{ field.filename || "Выберите файл" }}
            span(v-else-if='$store.getters.permissions.canEditDataVersion') {{ field.filename ? field.filename + " загружается" : "Выберите файл" }}
            input.TextInput.TextInput--block(
              type='file',
              :disabled='!$store.getters.permissions.canEditDataVersion && selectedService.id !== "workspace"',
              @input='changeFile(field, $event)'
            )
          .FileInput-file(v-else)
            a.OneLine(
              @click='getFile($event, field.url)',
              href='#'
            ) {{ field.urlName }}
            i.Icon.IconClose.Pointer(
              v-if='$store.getters.permissions.canEditDataVersion || selectedService.id === "workspace"',
              @click='removeUrl(field)'
            )
        number-box(
          v-if='field.type === "int" || field.type === "float"',
          :max='field.validated_options.max',
          :min='field.validated_options.min',
          :step='field.validated_options.step',
          :hasError='field.errors && field.errors.length > 0',
          v-model='field.value'
        )
        template(v-if='field.type === "adm_levels"')
          .ServiceField(v-for='level in field.value')
            switcher(v-model='level.isSelected') {{ level.name }}
        .Select(v-if='field.type === "select"')
          custom-select(
            placeholder='Выберите значение из списка',
            :isBoldSelected='true',
            :hasError='field.errors && field.errors.length > 0',
            @input='field.value = $event',
            :options='field.select',
            :value='field.value'
          )
        input-notification(
          v-for='error in field.errors',
          :key='error'
        ) {{ fieldErrors[error] }}
  .ServiceParams-log(v-if='!isLoading')
    .ServiceParams-label Отчет о предыдущем запуске
    //- Новый вывод лога в виде json-editor
    template(v-if='typeof log === "object" && !!log')
      json-editor.ServiceParams-log-json-editor(
        v-if='Object.keys(log).length > 0',
        :value='log',
        :schema='null',
        mode='view',
        :modes='null',
        :navigationBar='false'
      )
      //- Вывод ошибки сохраняется как был
      log.Version-log(
        v-if='error',
        text='',
        :errors='error'
      )
    //- Старый вывод лога в виде строки
    log.Version-log(
      v-if='typeof log === "string" || !log',
      :text='log',
      :errors='error'
    )
  .ServiceField(v-if='!isLoading && !canCalculate')
    input-notification Превышены системные лимиты
  .ServiceParams-actions(v-if='!isLoading')
    // button.Btn.Btn--block.Btn--outline(@click="startCurrentAndParent") Запустить предшествующие процессы и текущий
    // button.Btn.Btn--block.Btn--outline(@click="startParent") Запустить предшествующие процессы
    .ServiceParams-button-wrapper(v-if='$store.getters.permissions.canEditDataVersion')
      button.Btn.Btn--block.Btn--outline(
        v-if='selectedService.id !== "workspace"',
        @click='updateButtonParameters'
      ) Сохранить параметры
      button.Btn.Btn--block.Btn--outline(
        v-if='!selectedService.inactive',
        @click='startCurrent',
        :disabled='!canCalculate'
      ) Запустить процесс
</template>

<script>
import Switcher from '@/components/Switcher.vue'
import PeriodInterval from '@/components/PeriodInterval'
import Log from '@/components/modeling/Log.vue'
import periods from '@/mixins/periods'
import CustomSelect from '@/components/CustomSelect'
import FadeLoader from 'vue-spinner/src/FadeLoader'
import limits from '@/mixins/limits'
import serviceparameters from '@/mixins/serviceparameters'
import InputNotification from '../InputNotification'
import NumberBox from '@/components/NumberBox.vue'

export default {
  name: 'modeling-service-parameters',

  mixins: [periods, limits, serviceparameters],

  components: {
    InputNotification,
    PeriodInterval,
    Switcher,
    CustomSelect,
    Log,
    FadeLoader,
    NumberBox,
    'input-notification': () => import('@/components/InputNotification'),
    JsonEditor: () => import('@/components/JsonEditor')
  },

  computed: {
    workspace() {
      return this.$store.getters.workspace
    },

    version() {
      return this.$store.getters.version
    },

    selectedService() {
      return this.$store.getters.modelingSelectedService
    },

    modelingSelectedServiceDetails() {
      const modelingSelectedServiceDetails = this.$store.getters.modelingSelectedServiceDetails
      if (Array.isArray(modelingSelectedServiceDetails) && modelingSelectedServiceDetails.length > 0) {
        return modelingSelectedServiceDetails[0]
      }

      return null
    },

    selectedServiceDetails() {
      return this.modelingSelectedServiceDetails ? this.modelingSelectedServiceDetails.params || [] : []
    },

    log() {
      return this.modelingSelectedServiceDetails ? this.modelingSelectedServiceDetails.log : ''
    },

    error() {
      if (!this.modelingSelectedServiceDetails) {
        return null
      }

      if (this.modelingSelectedServiceDetails.error === 'nan') {
        return null
      }

      return this.modelingSelectedServiceDetails.error
    },

    admLevels() {
      return this.$store.getters.settings.administrative_levels ? this.$store.getters.settings.administrative_levels.filter((v) => v.adm_level !== 20) : []
    }
  },

  watch: {
    workspace(newVal, oldVal) {
      if (oldVal) {
        this.$store.dispatch('setModelingSelectedService', null)
      }
    },
    version(newVal, oldVal) {
      if (oldVal) {
        this.$store.dispatch('setModelingSelectedService', null)
      }
    },
    selectedService(newVal) {
      this.formFields = []
      this.getParams()
    }
  },

  beforeDestroy() {
    this.$store.dispatch('setModelingSelectedService', null)
    this.$store.dispatch('getModelingSelectedServiceDetails', null)
  },

  methods: {
    getParams() {
      this.isLoading = true
      const action = this.selectedService.id === 'workspace' ? 'getModelingInitWorkspaceDetails' : 'getModelingSelectedServiceDetails'
      this.$store
        .dispatch(action, this.selectedService.id)
        .catch((e) => {
          this.$store.commit('setApiErrorInfo', 'Ошибка получения списка параметров')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    /*startCurrentAndParent() {
        console.log('start cur and parent')
      },
      startParent() {
        console.log('start parent')
      },*/
    startCurrent() {
      this.$store.dispatch('getModelingLimits').then((r) => {
        if (!this.canCalculate) {
          this.showCanCalculateNotification()
          return
        }

        const fieldNameProperty = this.selectedService.id === 'workspace' ? 'name' : 'id'
        const requestParams = this.generateRequestParams(fieldNameProperty)
        if (!requestParams) {
          let message = 'Расчет не был запущен, т.к. в форма ввода параметров содержит ошибки. Устраните их и повторите попытку запуска расчета'
          if (this.selectedService.inactive) {
            message = 'Не удалось сохранить параметры сервиса, т.к. в форма ввода параметров содержит ошибки. Устраните их и повторите попытку запуска расчета'
          }

          this.$store.commit('setApiErrorInfo', message)
          return
        }

        if (this.selectedService.id !== 'workspace') {
          this.$store
            .dispatch('updateButtonParameters', requestParams.params)
            .then((v) => {
              if (this.selectedService.inactive) {
                this.$ui.toast.show({ text: 'Параметры сервиса сохранены успешно', type: 'success' })
                return
              }

              this.$store
                .dispatch('startService', { button: this.selectedService.id })
                .then((v) => {
                  this.$ui.toast.show({ text: 'Запуск сервисов прошел успешно', type: 'success' })
                  this.$store.dispatch('setModelingSelectedService', null)
                  this.$store.dispatch('getModelingTree')
                })
                .catch((e) => {
                  this.$store.commit('setApiErrorInfo', 'При запуске сервисов произошла ошибка. Сервисы не были запущены')
                })
            })
            .catch((e) => {
              this.$store.commit('setApiErrorInfo', 'Ошибка сохранения параметров')
            })
        } else {
          this.$store
            .dispatch('modelingInitWorkspace', requestParams)
            .then((v) => {
              this.$ui.toast.show({ text: 'Начат процесс создания рабочего пространства', type: 'success' })
              this.$store.dispatch('setModelingSelectedService', null)
            })
            .catch((e) => {
              this.$store.commit('setApiErrorInfo', 'При запуске процесса создания рабочего пространства произошла ошибка')
            })
        }
      })
    },

    updateButtonParameters() {
      //Для создания WS не нужно сохранения параметров
      if (this.selectedService.id === 'workspace') {
        return
      }

      const requestParams = this.generateRequestParams('id')
      if (!requestParams) {
        message = 'Не удалось сохранить параметры сервиса, т.к. в форма ввода параметров содержит ошибки. Устраните их и повторите попытку запуска расчета'
        this.$store.commit('setApiErrorInfo', message)
        return
      }

      this.$store
        .dispatch('updateButtonParameters', requestParams.params)
        .then(() => {
          this.$ui.toast.show({ text: 'Параметры сервиса сохранены успешно', type: 'success' })
        })
        .catch((e) => {
          this.$store.commit('setApiErrorInfo', 'Ошибка сохранения параметров')
        })
    },

    getFile(e, url) {
      e.preventDefault()
      this.$store.dispatch('getFile', url)
    }
  }
}
</script>
<style lang="scss">
@import '~base';

#app .ServiceParams {
  --titleText: #{$black4};
  --highlightBg: #{$grey12};
  --btnBorderColor: #{$grey3};
  --btnTextColor: #{$blue};
  --btnBg: transparent;
}

#app[data-theme='dark'] .ServiceParams {
  --valueText: #{$grey1};
  --highlightBg: #{$black3};
  --btnBorderColor: transparent;
  --btnTextColor: #{$white3};
  --btnBg: #{$blue};
}
</style>
<style scoped lang="scss">
@import '~base';

.ServiceParams {
  padding: 15px 17px 12px 12px;
  color: var(--basicText);
  font-size: 12px;

  &-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -16px 0 0 -16px;
  }

  &-fields {
    margin-top: 25px;
  }

  &-title {
    color: var(--titleText);
    font-family: 'Roboto Mono';
    text-transform: uppercase;
  }

  &-actions {
    padding-top: 10px;

    .Btn {
      margin-bottom: 13px;
      text-transform: uppercase;
      font-weight: 500;
      font-size: 11px;
      border-color: var(--btnBorderColor);
      color: var(--btnTextColor);
      background: var(--btnBg);

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &-log-json-editor {
    height: 180px;
  }

  &-button-wrapper {
    display: flex;
    flex-direction: row;
    gap: 8px;
  }
}

.ServiceField {
  margin-bottom: 20px;

  & & {
    padding: 3px 10px;
    margin: 0;

    &:nth-child(2n + 1) {
      background: var(--highlightBg);
    }
  }
}

.ListItem {
  display: flex;
  align-items: center;
  padding: 3px 10px;

  &-period {
    flex: 0 0 200px;
    width: 300px;
  }

  &-field {
    flex: 1 1 auto;
  }

  &:nth-child(2n + 1) {
    background: var(--highlightBg);
  }
}

.Select {
  height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/modeling/ServiceParameters.vue